import * as types from './mutation-types';
import ghUtils from '../lib/utils/ghUtils';
import getSortedTopics from '../lib/utils/getSortedTopics';

const { getUserRepos, getOrgRepos } = ghUtils('116423ec00659a0d15e2ee62d1a9778c3617f162');

export const updateOwner = async ({commit}, { owner, ownerType }) => {
  const payload = {};
  
  if (ownerType === 'org') {
    payload.repos = await getOrgRepos(owner);
  } else if (ownerType === 'user') {
    payload.repos = await getUserRepos(owner);
  }
  payload.topics = getSortedTopics(payload.repos);

  commit(types.UPDATE_OWNER, payload);
};

export const updateTopics = ({commit}, topics) => {
  commit(types.UPDATE_TOPICS, topics);
};

export const updateCapital = ({commit}, capital) => {
  commit(types.UPDATE_CAPITAL, capital);
};

export const updateLoaded = ({commit}, loaded) => {
  commit(types.UPDATE_LOADED, loaded);
};

export const updateLoadingError = ({commit}, loadingError) => {
  commit(types.UPDATE_LOADING_ERROR, loadingError);
}





// WEBPACK FOOTER //
// ./src/store/actions.js